import axios from "axios";
import jwtInterceptor from "./jwtInterceptor";
import errorInterceptor from "./errorInterceptor";
import { Album, AlbumImage } from "model/albumModel";

/**
 * Album di immagini di una task, sul backend statistiche Python.
 * BaseURL `${REACT_APP_STATS_BACKEND_BASE_URI}/tasks` (…/helpers/tasks).
 * Stesse rotte autenticate dello share: vedi backend_statistiche/app/controllers/albums.py.
 */
const instance = axios.create({
  baseURL: `${process.env.REACT_APP_STATS_BACKEND_BASE_URI}/tasks`,
  headers: { "Content-Type": "application/json" },
});

instance.interceptors.request.use(jwtInterceptor);
instance.interceptors.response.use(undefined, errorInterceptor);

export const listAlbums = async (
  idprocess: number,
  idorganization: number
): Promise<Album[]> => {
  const { data } = await instance.get(`/${idprocess}/albums`, {
    params: { idorganization },
  });
  return data?.data?.albums ?? [];
};

export const createAlbum = async (
  idprocess: number,
  idorganization: number,
  name: string,
  images: AlbumImage[]
): Promise<Album> => {
  const { data } = await instance.post(`/${idprocess}/albums`, {
    idorganization,
    name,
    images,
  });
  return data?.data;
};

export const updateAlbum = async (
  idalbum: number,
  idorganization: number,
  name: string,
  images: AlbumImage[]
): Promise<Album> => {
  const { data } = await instance.put(`/albums/${idalbum}`, {
    idorganization,
    name,
    images,
  });
  return data?.data;
};

export const deleteAlbum = async (
  idalbum: number,
  idorganization: number
): Promise<void> => {
  await instance.delete(`/albums/${idalbum}`, { params: { idorganization } });
};

export default instance;
